import { EpisodeOfCare } from '@/types/episodeOfCare';
import { ProgramQualification } from '@/types/person';

export interface Props {
  episodeOfCare?: EpisodeOfCare | null;
  programQualification?: ProgramQualification | null;
}

export enum SectionState {
  ENROLLING = 'ENROLLING',
  REJECTING = 'REJECTING',
  VIEWING = 'VIEWING'
}
